import { stepADAndDTugoLookup as expenseLookup } from './claimCodeMapper';

const OPTION_AIR_FLIGHT = 'Air Flight/Common Carrier Accident';
const OPTION_24_HOUR = '24-Hour Accident';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data) {
  return [];
}

function mapExpensesByType(data, itemsKey, expenseLookupKey, condition = true) {
  if (!condition || !data[itemsKey] || data[itemsKey].length < 1) {
    return [];
  }

  // Get claim code from associatedClaimCodes
  const lookup = expenseLookup[expenseLookupKey];
  const claimCode = lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
    ? lookup.associatedClaimCodes[0]
    : (lookup.claimCode || null);

  if (!claimCode) {
    return [];
  }
  const expenses = [];

  data[itemsKey].forEach((item) => {
    const expense = mapExpenseItem(item, data, claimCode);
    if (expense) {
      expenses.push(expense);
    }
  });

  return expenses;
}

function mapToExpenses(data) {
  const expensesSelected = Array.isArray(data.whatExpensesAreYouClaimingFor)
    ? data.whatExpensesAreYouClaimingFor
    : [];

  const expenseConfigs = [
    {
      items: 'airFlightCommonCarrierAccidentItems',
      lookup: 'airFlightCommonCarrierAccident',
      condition: expensesSelected.includes(OPTION_AIR_FLIGHT),
    },
    {
      items: 'accident24HourItems',
      lookup: 'accident24Hour',
      condition: expensesSelected.includes(OPTION_24_HOUR),
    },
  ];

  return expenseConfigs.flatMap((config) =>
    mapExpensesByType(data, config.items, config.lookup, config.condition)
  );
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = !Array.isArray(item.selectedClaimFor)
    ? (item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
      ? item.selectedClaimFor.toJS()
      : item.selectedClaimFor)
    : item.selectedClaimFor;
  const claimForInsuredIds = (selectedClaimForArray || []).map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: item.descriptionOfItem || '',
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray || [],
  };
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = (expenseLookup && expenseLookup.claimCodeList) || [];
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const expensesSelected = Array.isArray(data.whatExpensesAreYouClaimingFor)
    ? data.whatExpensesAreYouClaimingFor
    : [];

  if (expensesSelected.length < 1 || claimTypes === undefined) {
    return list;
  }

  const otherExpenses = mapToExpenses(data);

  const claimCodeMapping = {
    [expenseLookup.airFlightCommonCarrierAccident.claimCode]: OPTION_AIR_FLIGHT,
    [expenseLookup.accident24Hour.claimCode]: OPTION_24_HOUR,
  };

  claimTypes.forEach((item) => {
    const expenseType = claimCodeMapping[item.claimCode];
    if (expenseType && expensesSelected.includes(expenseType)) {
      list.push({
        claimCode: item.claimCode,
        description: expenseType,
        claimTypeId: item.claimTypeId,
        requiredDocuments: item.requiredDocuments,
        order: null,
        expenses: otherExpenses.filter((expense) => expense.claimTypeCode === item.claimCode),
      });
    }
  });

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepADAndDTugoDataMapper.js